import React from 'react'
import css from './style.css'
import Modal from '../modal'
import * as actions from '../../actions/settings'
import { connect } from 'react-redux'

const mapStateToProps = (state, ownProps) => {
  return {
    ...state.settings,
    currentUserIsAdmin: state.currentUser.admin
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMarkupType: (val) => {
      dispatch(actions.setMarkupType(val))
    }
  }
}

const PreferencesModal = props => {
  return (
    <Modal mini center isOpen={props.isOpen} onRequestClose={props.onRequestClose}>
      <p>Preferences</p>
      <ul className={css.preferences}>
        {props.currentUserIsAdmin && <li className={props.markupType === 'CP' ? css.active : ''} onClick={() => props.setMarkupType('CP')}>CP</li>}
        <li className={props.markupType === 'BP' ? css.active : ''} onClick={() => props.setMarkupType('BP')}>BP</li>
        <li className={props.markupType === 'SP' ? css.active : ''} onClick={() => props.setMarkupType('SP')}>SP</li>
      </ul>
    </Modal>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(PreferencesModal)



// WEBPACK FOOTER //
// ./src/components/preferences-modal/index.js